export enum MessageStatus {
    Queued = 0,
    Sent = 1,
    Failed = -1
}

export const MessageStatusMetadata = {
    '-1': {
        display: 'Failed',
        value: -1
    },
    '0': {
        display: 'Queued',
        value: 0
    },
    '1': {
        display: 'Sent',
        value: 1
    }
};
